import { createSelector } from "reselect";

export const countriesSelector = createSelector(
    state => state.services.countries,
    state => state
);